/* SAVID header cart badge - keeps the count in step with the real cart.
 *
 * Listens to Horizon's own cartLinesUpdate event, so the badge updates
 * for every add: the product page, the homepage bundle, the bundles
 * page cards, and any native Horizon add-to-cart alike.
 */
import { StandardEvents } from '@shopify/events';

const badges = document.querySelectorAll('[data-savid-cart-count]');
if (badges.length) {
  const paint = (n) => {
    badges.forEach((b) => {
      b.textContent = String(n);
      b.classList.toggle('is-empty', !n);
    });
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!event.promise) return;
    event.promise
      .then(({ cart, detail }) => {
        const n = (cart && cart.totalQuantity) != null
          ? cart.totalQuantity
          : (detail && detail.itemCount);
        if (n != null) paint(n);
      })
      .catch(() => { /* another listener reports the failure */ });
  });
}
